import ContractListPage from '../inquiries/ContractListPage';
import { PAYMENT_PENDING_LIST_STATUSES } from '../inquiries/contractTypes';

export default function PaymentPendingList() {
  return (
    <ContractListPage
      title="결제대기 목록"
      desc="MVP 준비 · 확인 · 계약 서명까지 마치고 최종결제를 기다리고 있는 건입니다."
      statusOptions={PAYMENT_PENDING_LIST_STATUSES}
      groupFilter={(item) => PAYMENT_PENDING_LIST_STATUSES.includes(item.status)}
    />
  );
}
